import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { IClientVarsService } from '../interfaces/client-vars-service.interface';
import { IClientVars } from '../interfaces/client-vars.interface';
import merge from 'lodash/merge';
import { EditEvents } from '../interfaces/event.interface';
import { SlideDataServices } from '../slide-data-services.core';

export const V3_DEVR = '3.0.0';

export class ClientVarsService implements IClientVarsService {
    public constructor(private clientVars: IClientVars) {}

    public getClientVars(): IClientVars {
        return this.clientVars;
    }

    public setClientVars(clientVars: IClientVars) {
        merge(this.clientVars, clientVars);
        SlideDataServices.EventManager()?.emit(EditEvents.ClientVarChanged, this.clientVars);
    }

    public getCloneClientVars(): IClientVars {
        return JSON.parse(JSON.stringify(this.clientVars));
    }

    public setInitialAttributedText(text: string) {
        const { collab_client_vars: collabClientVars = {} } = this.clientVars;

        collabClientVars.initialAttributedText = collabClientVars.initialAttributedText ?? {};
        collabClientVars.initialAttributedText.text = text;

        this.clientVars.collab_client_vars = collabClientVars;
    }

    public isV3Data(): boolean {
        return this.clientVars.collab_client_vars?.dver === V3_DEVR;
    }

    public isLocalDoc(): boolean {
        return this.clientVars.padStatus === 'new';
    }

    public isPCLocalEdit(): boolean {
        return ENV.IS_PC_LOCAL_EDIT;
    }

    public isLocalEdit(): boolean {
        return ENV.IS_LOCAL_EDIT;
    }
}
